import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAppConfig } from '../configService'

export const useAppConfig = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.APP_CONFIG],
    queryFn: getAppConfig,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  })
}
